export default __webpack_public_path__ + "static/personal-b76216bb2af3013ab81c66da1be5b530.png";